var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.51,
    height: 44.51,
    viewBox: "0 0 44.51 44.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11751.604 -9124.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8,0A18.8,18.8,0,1,0,37.6,18.8,18.828,18.828,0,0,0,18.8,0Zm5.532,10.83a.27.27,0,0,1-.281.281H21.66a1.061,1.061,0,0,0-1.078,1.078v2.485h3.376a.264.264,0,0,1,.281.328l-.281,3.516a.3.3,0,0,1-.281.281H20.582V30.521a.27.27,0,0,1-.281.281H16.034a.27.27,0,0,1-.281-.281V18.847H13.6a.27.27,0,0,1-.281-.281V15a.27.27,0,0,1,.281-.281h2.157V11.3a4.3,4.3,0,0,1,4.313-4.313H24.1a.27.27,0,0,1,.281.281V10.83Z",
    transform: "translate(11755.604 9129.813)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.9ae548c95bdd07002ef29e9c752c9ed6.svg";
export { ForwardRef as ReactComponent };